// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const webOrderNumberStyles: SearchTextFieldStyles = {};
const styles = webOrderNumberStyles;

const OrderHistorySearchWebOrderNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="webOrderNumber"
            label={translate("Order Upload Reference #")}
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterWebOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchWebOrderNumber,
    definition: {
        group: "Order History",
        displayName: "Web Order Number",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
